import React from "react";
import { Button, TableAdv } from "../../../../../../components";
import { dateFormator, mapTableRows } from "../../../../../../utils";

const OtherH1BRecords = () => {
  const tableData = [];
  const columns = [
    {
      key: "receiptNumber",
      label: "Receipt Number",
    },
    {
      key: "lcaNumber",
      label: "LCA Number",
    },
    {
      key: "recordStatus",
      label: "Record Status",
    },
    {
      key: "h1bType",
      label: "H-1B Type",
    },
    {
      key: "filedDate",
      label: "Filed Date",
      render: (row) => dateFormator(row.filedDate, "month-day-year"),
    },
    {
      key: "status",
      label: "Status",
    },
    {
      key: "approvedUntil",
      label: "Approved Until",
    },
    // {
    //   key: "actions",
    //   label: "Actions",
    //   render: (row) => (
    //     <div className="flex gap-1">
    //       <Button
    //         type="icon"
    //         icon="edit_square"
    //         color="black"
    //         variant="text"
    //         size="xs"
    //       />
    //       <Button
    //         type="icon"
    //         icon="delete"
    //         color="black"
    //         variant="text"
    //         size="xs"
    //       />
    //     </div>
    //   ),
    // },
  ];
  const mappedRows = mapTableRows(tableData, columns);
  return (
    <div>
      <div className="my-6">
        <TableAdv tableId={`immigration_h1b_h1bview_otherh1brecords`} rows={mappedRows} columns={columns} hideToolBar />
      </div>
    </div>
  );
};

export default OtherH1BRecords;
